export default {
  dev: {
    baseURL: 'https://shopgwdev.gtdreamlife.com',
    openUrl: 'https://greenshop-dev.gtdreamlife.com/openplatform#/',
    adminUrl: 'https://greenshop-dev.gtdreamlife.com/operation',
    futureUrl: 'https://futurestore-dev.gtdreamlife.com',
    liantongUrl: 'https://saas.smart.ictsoft.cn/saas-om'
  },
  uat: {
    baseURL: 'https://shopgwuat.gtdreamlife.com',
    openUrl: 'https://greenshop-uat.gtdreamlife.com/openplatform#/',
    adminUrl: 'https://greenshop-uat.gtdreamlife.com/operation',
    futureUrl: 'https://futurestore-uat.gtdreamlife.com',
    liantongUrl: 'https://saas.smart.ictsoft.cn/saas-om'
  },
  test: {
    baseURL: 'https://shopgwtest.gtdreamlife.com',
    openUrl: 'https://greenshop-test.gtdreamlife.com/openplatform#/',
    adminUrl: 'https://greenshop-test.gtdreamlife.com/operation',
    futureUrl: 'https://futurestore-test.gtdreamlife.com',
    liantongUrl: 'https://saas.smart.ictsoft.cn/saas-om'
  },
  prod: {
    baseURL: 'https://shopgw.gtdreamlife.com',
    openUrl: 'https://openplatform.gtdreamlife.com/#/',
    adminUrl: 'https://greenshop.gtdreamlife.com/operation',
    futureUrl: 'https://futurestore.gtdreamlife.com',
    liantongUrl: 'https://saas.smart.ictsoft.cn/saas-om'
  }
}



// WEBPACK FOOTER //
// ./src/constants/env.js